import { NEUTRAL_HUE, zezamiiAccess, zezamiiNeutral } from 'theme/brandTokens';
import { ROLE_LABEL, rolesConfig } from './rolesConfig';

// How each role reads on screen (label, hue, glyph), shared by the Roles stat cards and table tags.
// Listed in hierarchy order, which is also the order the Roles card lists them.
export const ROLE_DISPLAY = [
	{
		key: 'globalAdmin',
		label: ROLE_LABEL[rolesConfig.GLOBAL_ADMIN],
		color: zezamiiAccess.access4,
		icon: 'globe',
		ids: [rolesConfig.GLOBAL_ADMIN]
	},
	{
		key: 'siteAdmin',
		label: ROLE_LABEL[rolesConfig.SITE_ADMIN],
		color: '#5FC4D9',
		icon: 'building',
		ids: [rolesConfig.SITE_ADMIN]
	},
	{
		key: 'globalReadOnly',
		label: ROLE_LABEL[rolesConfig.GLOBAL_READ_ONLY],
		color: zezamiiNeutral.grey500,
		icon: 'eye',
		readOnly: true,
		ids: [rolesConfig.GLOBAL_READ_ONLY]
	},
	{
		key: 'siteReadOnly',
		label: ROLE_LABEL[rolesConfig.SITE_READ_ONLY],
		color: zezamiiNeutral.grey400,
		icon: 'eye',
		readOnly: true,
		ids: [rolesConfig.SITE_READ_ONLY]
	},
	{ key: 'developer', label: 'Developer', color: '#8B5CF6', icon: 'code', ids: [rolesConfig.DEVELOPER] },
	{
		key: 'installer',
		label: ROLE_LABEL[rolesConfig.INSTALLER],
		color: '#1E3A8A',
		icon: 'wrench',
		ids: [rolesConfig.INSTALLER]
	},
	{ key: 'floorAdmin', label: 'Floor Admin', icon: 'floor', ids: [rolesConfig.FLOOR_ADMIN] },
	{ key: 'teamAdmin', label: 'Team Admin', icon: 'users', ids: rolesConfig.TEAM_ADMIN }
];

// Zezamii staff role: only staff see it on the cards.
export const STAFF_ROLE_IDS = [rolesConfig.DEVELOPER];
// Never on the cards: 113 is an app-only mirror of every 201 holder, not a Dashboard admin.
export const HIDDEN_ROLE_IDS = [rolesConfig.APP_GLOBAL_ADMIN];

// Neutral hue and glyph for roles without their own.
export const OTHER_ROLE_DISPLAY = Object.freeze({ color: NEUTRAL_HUE, icon: 'user' });

// Names of the remaining registry roles; NOT in ROLE_LABEL, which also gates admin-only views.
export const REGISTRY_ROLE_LABEL = {
	[rolesConfig.BILLING_ADMIN]: 'Billing Admin',
	[rolesConfig.ASSETS_ADMIN]: 'Assets Admin',
	[rolesConfig.SITE_LOCK_ADMIN]: 'Site Lock Admin',
	[rolesConfig.MOBILE_MANAGER]: 'Mobile Manager',
	[rolesConfig.APP_GLOBAL_ADMIN]: 'App Global Admin',
	[rolesConfig.APP_SITE_ADMIN]: 'App Site Admin',
	[rolesConfig.OWNER_APP_DIRECT]: 'Owner App Direct'
};

// A role's place in the hierarchy (ROLE_DISPLAY order); roles without an entry sort last.
export const roleRank = (permissionID) => {
	const i = ROLE_DISPLAY.findIndex((display) => display.ids.includes(permissionID));
	return i === -1 ? ROLE_DISPLAY.length : i;
};

// A permission's display entry; unknown ids read "Other role", never a raw number.
export const roleDisplay = (permissionID) =>
	ROLE_DISPLAY.find((r) => r.ids.includes(permissionID)) || {
		...OTHER_ROLE_DISPLAY,
		label: REGISTRY_ROLE_LABEL[permissionID] || 'Other role'
	};
